export const headerMock = {
  id: 467,
  slug: 'header',
  createdAt: '2025-08-14T06:10:41.958Z',
  updatedAt: '2026-06-10T08:15:05.393Z',
  publishedAt: '2026-06-10T08:15:07.818Z',
  locale: 'en',
  showLanguages: true,
  logoLink: '/',
  logoAlignment: 'left',
  documentId: 'a5634w4em0wm7ah01e35l4ed',
  header: {
    id: 325,
    firstLevels: [
      {
        id: 1490,
        level: '1',
        title: 'Proxies',
        badge: null,
        secondLevels: [
          {
            id: 3256,
            level: '2',
            title: ' ',
            hideTitleOnMobile: true,
            hideSectionOnMobile: false,
            badge: null,
            link: {
              id: 133076,
              text: 'Proxies',
              url: '/proxies',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            thirdLevels: [
              {
                id: 18368,
                level: '3',
                title: 'Residential Proxies',
                description:
                  'Access 115M+ real-user IPs across 195+ locations for high success rates, precise geo-targeting, and effortless scale.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133131,
                  text: 'proxies',
                  url: '/proxies/residential-proxies',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329652,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18369,
                level: '3',
                title: 'ISP Proxies',
                description:
                  'Get residential credibility with datacenter-level speed for stable sessions and traffic-heavy workflows.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133132,
                  text: 'asd',
                  url: '/proxies/isp-proxies',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329653,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18370,
                level: '3',
                title: 'Mobile Proxies',
                description:
                  'Tap into 10M+ ethically-sourced IPs across 160+ locations to bypass even the toughest mobile-first blocks.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133133,
                  text: 'asd',
                  url: '/proxies/mobile',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329654,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
            ],
          },
          {
            id: 3254,
            level: '2',
            title: ' ',
            hideTitleOnMobile: false,
            hideSectionOnMobile: false,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18360,
                level: '3',
                title: 'Datacenter Proxies',
                description:
                  'Run high-volume tasks at maximum speed with 500K+ fast, reliable datacenter IPs from global locations.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133078,
                  text: null,
                  url: '/proxies/datacenter-proxies',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329644,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 33,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18361,
                level: '3',
                title: 'Site Unblocker',
                description:
                  'Access real-time data from even the most protected websites with automatic proxy rotation and CAPTCHA handling.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133079,
                  text: null,
                  url: '/proxies/site-unblocker',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329645,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 33,
                    height: 32,
                    caption: null,
                  },
                },
              },
            ],
          },
          {
            id: 3248,
            level: '2',
            title: 'Features',
            hideTitleOnMobile: null,
            hideSectionOnMobile: true,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18324,
                level: '3',
                title: 'Compare Products',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133080,
                  text: 'Compare Prod',
                  url: '/compare',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18325,
                level: '3',
                title: 'Proxy Servers',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133081,
                  text: 'proxy',
                  url: '/proxies/buy',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18326,
                level: '3',
                title: 'Cheap Proxies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133082,
                  text: 'test',
                  url: '/proxies/cheap',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18327,
                level: '3',
                title: 'Static Residential Proxies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133083,
                  text: 'Static residential proxies',
                  url: '/proxies/static-residential-proxies',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18328,
                level: '3',
                title: 'SOCKS5 Proxies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133084,
                  text: 'SOCKS5 proxies',
                  url: '/proxies/socks5',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18329,
                level: '3',
                title: 'Rotating Proxies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133085,
                  text: 'Rotating proxies',
                  url: '/proxies/rotating-proxies',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18330,
                level: '3',
                title: 'All Proxy Features',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133086,
                  text: 'test',
                  url: '/proxies/features',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
        ],
        extraInfo: [],
        carousel: null,
        extraGroup: [
          {
            id: 625,
            title: 'DISCOVER',
            link: null,
            list: [
              {
                id: 18387,
                level: '1',
                title: 'Discord',
                description:
                  'Connect with our advanced support, engage with like-minded users, and get fresh news from our team.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133142,
                  text: 'test',
                  url: 'https://discord.com/invite/WQHGnpgJfC',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18388,
                level: '2',
                title: 'GitHub',
                description:
                  'Explore advanced integration guides of our solutions and third-party tools in your projects',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133143,
                  text: 'test',
                  url: 'https://github.com/Decodo',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
        ],
        promoBanners: [
          {
            id: 172,
            title: 'Targeting upgrade',
            description: 'Continent-level targeting now available!',
            link: {
              id: 133146,
              text: 'test',
              url: 'https://decodo.com/proxies/residential-proxies',
              openInNewTab: false,
              variant: null,
              color: null,
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            image: {
              id: 329669,
              isExpandable: false,
              altText: '',
              image: {
                url: '/images/visual-test-icon.svg',
                alternativeText: null,
                width: 72,
                height: 72,
                caption: null,
              },
            },
          },
        ],
      },
      {
        id: 1489,
        level: '1',
        title: 'Scraping',
        badge: {
          id: 3243,
          text: 'NEW',
          variant: 'outlined',
          size: 's',
          color: 'gradient',
        },
        secondLevels: [
          {
            id: 3261,
            level: '2',
            title: ' ',
            hideTitleOnMobile: null,
            hideSectionOnMobile: null,
            badge: null,
            link: {
              id: 133121,
              text: 'Scraping',
              url: '/scraping',
              openInNewTab: false,
              variant: null,
              color: 'primary',
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            thirdLevels: [
              {
                id: 18386,
                level: '3',
                title: 'Web Scraping API',
                description:
                  'Configure scraping power per request through one unified API, enabling only the capabilities you need and paying in credits based on actual request complexity.',
                showArrow: false,
                highlighted: true,
                link: {
                  id: 133137,
                  text: 'test',
                  url: '/scraping/web',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: {
                  id: 3247,
                  text: 'NEW',
                  variant: 'outlined',
                  size: 's',
                  color: 'gradient',
                },
                price: null,
                image: {
                  id: 329668,
                  isExpandable: false,
                  altText: 'Icon Scrapers',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 64,
                    height: 64,
                    caption: null,
                  },
                },
              },
              {
                id: 18381,
                level: '3',
                title: 'Scraping Templates',
                description:
                  'Launch pre-built scrapers for popular websites and start collecting data in just a few clicks.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133138,
                  text: null,
                  url: '/scraping/templates',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329665,
                  isExpandable: false,
                  altText: 'Scraping capabilities',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18382,
                level: '3',
                title: 'AI Parser',
                description:
                  'Turn raw HTML into clean, structured data automatically, no parsing logic or custom code needed.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133139,
                  text: null,
                  url: '/scraping/ai',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329666,
                  isExpandable: false,
                  altText: 'Web 1',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
            ],
          },
          {
            id: 3252,
            level: '2',
            title: 'Types',
            hideTitleOnMobile: null,
            hideSectionOnMobile: null,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18351,
                level: '3',
                title: 'eCommerce',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133122,
                  text: null,
                  url: '/scraping/ecommerce',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18352,
                level: '2',
                title: 'SERP',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133123,
                  text: null,
                  url: '/scraping/serp',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18353,
                level: '2',
                title: 'Social Media',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133124,
                  text: null,
                  url: '/scraping/social-media',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
          {
            id: 3253,
            level: '2',
            title: 'Targets',
            hideTitleOnMobile: null,
            hideSectionOnMobile: null,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18354,
                level: '3',
                title: 'Amazon',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133125,
                  text: null,
                  url: '/scraping/ecommerce/amazon',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18355,
                level: '3',
                title: 'Google',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133126,
                  text: null,
                  url: '/scraping/serp/google-search',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18356,
                level: '3',
                title: 'Bing',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133127,
                  text: null,
                  url: '/scraping/serp/bing',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18357,
                level: '3',
                title: 'TikTok',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133128,
                  text: null,
                  url: '/scraping/social-media/tiktok',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18358,
                level: '3',
                title: 'Zillow',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133129,
                  text: null,
                  url: '/scraping/web/zillow',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18359,
                level: '3',
                title: 'All targets',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133130,
                  text: null,
                  url: '/targets',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
        ],
        extraInfo: [],
        carousel: null,
        extraGroup: [
          {
            id: 626,
            title: 'Discover',
            link: null,
            list: [
              {
                id: 18389,
                level: '1',
                title: 'Discord',
                description:
                  'Connect with our advanced support, engage with like-minded users, and get fresh news from our team.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133144,
                  text: 'test',
                  url: 'https://discord.com/invite/WQHGnpgJfC',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18390,
                level: '1',
                title: 'GitHub',
                description:
                  'Explore advanced integration guides of our solutions and third-party tools in your projects',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133145,
                  text: 'test',
                  url: 'https://github.com/Decodo',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
        ],
        promoBanners: [],
      },
      {
        id: 1488,
        level: '1',
        title: 'Pricing',
        badge: null,
        secondLevels: [
          {
            id: 3258,
            level: '2',
            title: 'Proxies',
            hideTitleOnMobile: null,
            hideSectionOnMobile: null,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18374,
                level: '3',
                title: 'Residential Proxies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133087,
                  text: 'Residential proxis',
                  url: '/proxies/residential-proxies/pricing',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: {
                  id: 2493,
                  pricePer: 'GB',
                  price: 2,
                },
                image: {
                  id: 329658,
                  isExpandable: false,
                  altText: 'Residential',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18375,
                level: '3',
                title: 'Static Residential Proxies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133088,
                  text: 'ISP proxies',
                  url: '/proxies/isp-proxies/pricing',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: {
                  id: 2494,
                  pricePer: 'IP',
                  price: 0.27,
                },
                image: {
                  id: 329659,
                  isExpandable: false,
                  altText: 'Static residential',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18376,
                level: '3',
                title: 'Mobile Proxies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133089,
                  text: 'Mobile Proxies',
                  url: '/proxies/mobile/pricing',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: {
                  id: 2495,
                  pricePer: 'GB',
                  price: 2.25,
                },
                image: {
                  id: 329660,
                  isExpandable: false,
                  altText: 'Mobile',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18377,
                level: '3',
                title: 'Datacenter Proxies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133090,
                  text: 'Datacenter Proxies',
                  url: '/proxies/datacenter-proxies/pricing',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: {
                  id: 2496,
                  pricePer: 'IP',
                  price: 0.02,
                },
                image: {
                  id: 329661,
                  isExpandable: false,
                  altText: 'Datacenter',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 33,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18378,
                level: '3',
                title: 'Site Unblocker',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133091,
                  text: 'rts',
                  url: '/proxies/site-unblocker/pricing',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: {
                  id: 2497,
                  pricePer: 'ww1K-req',
                  price: 0.95,
                },
                image: {
                  id: 329662,
                  isExpandable: false,
                  altText: 'Site Unblocker',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
            ],
          },
          {
            id: 3260,
            level: '2',
            title: 'Scraping APIs',
            hideTitleOnMobile: false,
            hideSectionOnMobile: false,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18383,
                level: '3',
                title: 'Web Scraping API  ',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133092,
                  text: 'Scraping API',
                  url: '/scraping/web/pricing',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: {
                  id: 3244,
                  text: 'New',
                  variant: 'outlined',
                  size: 's',
                  color: 'gradient',
                },
                price: {
                  id: 2498,
                  pricePer: 'ww1K-req',
                  price: 0.09,
                },
                image: {
                  id: 329667,
                  isExpandable: false,
                  altText: 'Core scraping',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
            ],
          },
          {
            id: 3257,
            level: '3',
            title: 'Free Tools',
            hideTitleOnMobile: false,
            hideSectionOnMobile: false,
            badge: null,
            link: {
              id: 133077,
              text: 'Free tools',
              url: '/apps',
              openInNewTab: false,
              variant: null,
              color: 'primary',
              rel: null,
              phTracker: null,
              leftSection: null,
              rightSection: null,
            },
            thirdLevels: [
              {
                id: 18371,
                level: '3',
                title: 'Chrome Proxy Extension',
                description:
                  'Bring essential proxy features right into your browser.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133134,
                  text: 'Chrome extention',
                  url: '/apps/proxy-extension',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329655,
                  isExpandable: false,
                  altText: 'Smartproxy Chrome Extension',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18372,
                level: '3',
                title: 'Firefox Add-on',
                description:
                  'Get proxies to your favorite browser with a few clicks.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133135,
                  text: 'Firefix add-on',
                  url: '/apps/firefox-proxy-add-on',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329656,
                  isExpandable: false,
                  altText: 'Smartproxy Firefox Extension',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18373,
                level: '3',
                title: 'Proxy Checker',
                description:
                  'Test lists of proxies to avoid potential errors. ',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133136,
                  text: 'Proxy checker',
                  url: '/apps/proxy-checker',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329657,
                  isExpandable: false,
                  altText: null,
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: 'Proxy-Checker-icon',
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
            ],
          },
        ],
        extraInfo: [],
        carousel: null,
        extraGroup: [],
        promoBanners: [],
      },
      {
        id: 1486,
        level: '1',
        title: 'Data for AI',
        badge: null,
        secondLevels: [
          {
            id: 3259,
            level: '2',
            title: ' ',
            hideTitleOnMobile: false,
            hideSectionOnMobile: false,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18379,
                level: '3',
                title: 'AI Hub',
                description:
                  'Your launchpad for AI-powered data workflows to collect, structure, and deliver web data built for various AI use cases.',
                showArrow: false,
                highlighted: true,
                link: {
                  id: 133093,
                  text: null,
                  url: '/ai',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: {
                  id: 3245,
                  text: 'NEW',
                  variant: 'outlined',
                  size: 's',
                  color: 'gradient',
                },
                price: null,
                image: {
                  id: 329663,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 36,
                    height: 36,
                    caption: null,
                  },
                },
              },
              {
                id: 18362,
                level: '3',
                title: 'High-Speed Proxies',
                description:
                  'Power your AI pipelines with high-speed proxy infrastructure built for scale. ',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133094,
                  text: 'High-speed proxies',
                  url: '/proxies/high-speed-proxies',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329646,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 64,
                    height: 64,
                    caption: null,
                  },
                },
              },
              {
                id: 18363,
                level: '3',
                title: 'Video Downloader',
                description:
                  'Get large amounts of video and audio from YouTube with our enterprise-ready solution.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133095,
                  text: 'Video downloader',
                  url: '/scraping/video-downloader',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329647,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 64,
                    height: 64,
                    caption: null,
                  },
                },
              },
              {
                id: 18380,
                level: '3',
                title: 'Fast Search API',
                description:
                  'Retrieve structured search results at scale with ultra-low latency and built-in anti-blocking.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133096,
                  text: 'Fast Search API',
                  url: '/scraping/fast-search-api',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: {
                  id: 3246,
                  text: 'NEW',
                  variant: 'outlined',
                  size: 's',
                  color: 'gradient',
                },
                price: null,
                image: {
                  id: 329664,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 512,
                    height: 512,
                    caption: null,
                  },
                },
              },
            ],
          },
          {
            id: 3255,
            level: '2',
            title: 'Integrations',
            hideTitleOnMobile: false,
            hideSectionOnMobile: false,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18364,
                level: '3',
                title: 'n8n Integration',
                description:
                  'Automate web data workflows by scraping any website directly inside n8n using a drag-and-drop node.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133097,
                  text: null,
                  url: '/integrations/n8n',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329648,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 73,
                    height: 73,
                    caption: null,
                  },
                },
              },
              {
                id: 18365,
                level: '3',
                title: 'LangChain Integration',
                description:
                  'Fetch, clean, and plug web data directly into AI workflows with the official Decodo LangChain loader.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133098,
                  text: null,
                  url: '/integrations/langchain',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329649,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 36,
                    height: 36,
                    caption: null,
                  },
                },
              },
              {
                id: 18366,
                level: '3',
                title: 'MCP Server',
                description:
                  'Connect LLMs and AI agents to live web data through a standardized MCP interface.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133099,
                  text: null,
                  url: '/scraping/mcp-server',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329650,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
              {
                id: 18367,
                level: '3',
                title: 'OpenClaw Integration',
                description:
                  'Extract structured web data, handle dynamic pages, and bypass blocks with the official OpenClaw integration.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133100,
                  text: 'OpenClaw Integration',
                  url: '/integrations/openclaw-integration',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: {
                  id: 329651,
                  isExpandable: false,
                  altText: '',
                  image: {
                    url: '/images/visual-test-icon.svg',
                    alternativeText: null,
                    width: 32,
                    height: 32,
                    caption: null,
                  },
                },
              },
            ],
          },
          {
            id: 3249,
            level: '2',
            title: 'Use cases',
            hideTitleOnMobile: false,
            hideSectionOnMobile: false,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18331,
                level: '3',
                title: 'Large-Scale Data Collection',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133101,
                  text: null,
                  url: '/use-cases/large-scale-data-collection',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18332,
                level: '3',
                title: 'RAG (Retrieval-Augmented Generation)',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133102,
                  text: null,
                  url: '/use-cases/rag',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18333,
                level: '3',
                title: 'AI Agent Enablement',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133103,
                  text: null,
                  url: '/use-cases/ai-agent-enablement',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
        ],
        extraInfo: [],
        carousel: null,
        extraGroup: [],
        promoBanners: [],
      },
      {
        id: 1487,
        level: '1',
        title: 'Resources',
        badge: null,
        secondLevels: [
          {
            id: 3250,
            level: '2',
            title: 'Setup',
            hideTitleOnMobile: false,
            hideSectionOnMobile: false,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18334,
                level: '3',
                title: 'Product Comparison',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133104,
                  text: 'te',
                  url: '/compare',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18335,
                level: '3',
                title: 'Documentation',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133105,
                  text: 't',
                  url: 'https://help.decodo.com/docs/introduction',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18336,
                level: '3',
                title: 'Quick Start Guide',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133106,
                  text: 'et',
                  url: '/decodo-quick-start-guide',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18337,
                level: '3',
                title: 'FAQ',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133107,
                  text: 'te',
                  url: '/faq',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18338,
                level: '3',
                title: 'Integrations',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133108,
                  text: 'te',
                  url: '/integrations',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18339,
                level: '3',
                title: 'Knowledge Hub',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133109,
                  text: null,
                  url: '/devs',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18340,
                level: '3',
                title: 'Blog',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133110,
                  text: null,
                  url: '/blog',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18341,
                level: '3',
                title: 'Glossary',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133111,
                  text: null,
                  url: '/glossary',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18342,
                level: '3',
                title: 'Dynamic Pricing Index',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133112,
                  text: null,
                  url: '/ecommerce',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18343,
                level: '3',
                title: 'Case Studies',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133113,
                  text: null,
                  url: '/case-studies',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
          {
            id: 3251,
            level: '2',
            title: 'Locations',
            hideTitleOnMobile: false,
            hideSectionOnMobile: false,
            badge: null,
            link: null,
            thirdLevels: [
              {
                id: 18344,
                level: '3',
                title: 'United States',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133114,
                  text: 'te',
                  url: '/proxies/list/north-america/usa',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18345,
                level: '3',
                title: 'United Kingdom',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133115,
                  text: 'te',
                  url: '/proxies/list/europe/united-kingdom',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18346,
                level: '3',
                title: 'Turkey',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133116,
                  text: null,
                  url: '/proxies/list/asia/turkey',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18347,
                level: '3',
                title: 'Australia',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133117,
                  text: null,
                  url: '/proxies/list/australia',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18348,
                level: '3',
                title: 'China',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133118,
                  text: null,
                  url: '/proxies/list/asia/china',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18349,
                level: '3',
                title: 'India',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133119,
                  text: null,
                  url: '/proxies/list/asia/india',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18350,
                level: '3',
                title: 'All Locations',
                description: null,
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133120,
                  text: null,
                  url: '/proxies/list',
                  openInNewTab: false,
                  variant: null,
                  color: 'primary',
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
        ],
        extraInfo: [],
        carousel: null,
        extraGroup: [
          {
            id: 624,
            title: 'DISCOVER',
            link: null,
            list: [
              {
                id: 18384,
                level: '3',
                title: 'Discord',
                description:
                  'Connect with our advanced support, engage with like-minded users, and get fresh news from our team.',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133140,
                  text: 'te',
                  url: 'https://discord.com/invite/WQHGnpgJfC',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
              {
                id: 18385,
                level: '3',
                title: 'GitHub',
                description:
                  'Explore advanced integration guides of our solutions and third-party tools in your projects',
                showArrow: false,
                highlighted: null,
                link: {
                  id: 133141,
                  text: 'te',
                  url: 'https://github.com/Decodo',
                  openInNewTab: false,
                  variant: null,
                  color: null,
                  rel: null,
                  phTracker: null,
                  leftSection: null,
                  rightSection: null,
                },
                badge: null,
                price: null,
                image: null,
              },
            ],
          },
        ],
        promoBanners: [],
      },
    ],
  },
  logo: {
    id: 329670,
    isExpandable: false,
    altText: null,
    image: {
      url: '/images/visual-test-icon.svg',
      alternativeText: 'Decodo Logo',
      width: 125,
      height: 20,
      caption: 'Decodo Logo',
    },
  },
  extraSectionLinks: [
    {
      id: 133147,
      text: 'Talk to data expert',
      url: '#contact-sales',
      openInNewTab: false,
      variant: 'text',
      color: 'primary',
      rel: null,
      phTracker: null,
      leftSection: null,
      rightSection: null,
    },
    {
      id: 133148,
      text: 'Log in',
      url: 'https://dashboard.decodo.com/login',
      openInNewTab: false,
      variant: 'text',
      color: 'primary',
      rel: null,
      phTracker: null,
      leftSection: null,
      rightSection: null,
    },
    {
      id: 133149,
      text: 'Start for free',
      url: 'https://dashboard.decodo.com/register',
      openInNewTab: false,
      variant: 'outlined',
      color: 'tertiary',
      rel: null,
      phTracker: null,
      leftSection: null,
      rightSection: null,
    },
  ],
  localizations: [],
};
